import * as jotai from 'jotai'

export const MOBILE_FILTER_SHARED_STATE = jotai.atom(false)

export function useControls() {
  return jotai.useAtom(MOBILE_FILTER_SHARED_STATE)
}
